// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var Js_json = require("bs-platform/lib/js/js_json.js");
var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Plate$BwaxMobile = require("../../../bwax-js/ml/plate.bs.js");
var JsonUtils$BwaxMobile = require("../../../bwax-js/re/utils/JsonUtils.bs.js");

function get(k, l) {
  var match = Plate$BwaxMobile.List.assoc(k, l);
  if (match !== undefined) {
    return Caml_option.valFromOption(match);
  }
  
}

function set(k, v, l) {
  return /* :: */[
          /* tuple */[
            k,
            v
          ],
          l
        ];
}

var keys = Plate$BwaxMobile.List.assoc_keys;

function dictToOptionAssoc(d) {
  return Plate$BwaxMobile.List.map((function (param) {
                return /* tuple */[
                        param[0],
                        Caml_option.some(param[1])
                      ];
              }), Curry._1(Plate$BwaxMobile.List.from_array, Js_dict.entries(d)));
}

function optionAssocToDict(al) {
  return Js_dict.fromList(Plate$BwaxMobile.List.keep_map((function (param) {
                    var k = param[0];
                    return Plate$BwaxMobile.$$Option.map((function (v) {
                                  return /* tuple */[
                                          k,
                                          v
                                        ];
                                }), param[1]);
                  }), Plate$BwaxMobile.List.rev(al)));
}

var mergeWith = Belt_List.concat;

function takeInExcluding(obj, excludingKeys, subj) {
  return Plate$BwaxMobile.List.foldl((function (acc, param) {
                var k = param[0];
                if (Plate$BwaxMobile.List.is_in((function (a, b) {
                          return a === b;
                        }), excludingKeys, k)) {
                  return acc;
                } else {
                  return /* :: */[
                          /* tuple */[
                            k,
                            param[1]
                          ],
                          acc
                        ];
                }
              }), subj, obj);
}

function toDict(al) {
  return Js_dict.fromList(Plate$BwaxMobile.List.rev(al));
}

function deriveDirtyValues(validated, lastSaved) {
  return Plate$BwaxMobile.List.foldl((function (acc, key) {
                var v = get(key, validated);
                var s = get(key, lastSaved);
                var dirty = v !== undefined ? (
                    s !== undefined ? !JsonUtils$BwaxMobile.isJsonEqual(Caml_option.valFromOption(v), Caml_option.valFromOption(s)) : true
                  ) : s !== undefined;
                if (dirty) {
                  return set(key, v, acc);
                } else {
                  return acc;
                }
              }), /* [] */0, keys(validated));
}

function buildInitialState(defaultValues, initialValues, fixedValues) {
  var first = Belt_List.concat(defaultValues, initialValues);
  var actualInitialValues = Belt_List.concat(first, fixedValues);
  var partial_arg = Plate$BwaxMobile.$$Option.and_then;
  return /* record */[
          /* actualInitialValues */actualInitialValues,
          /* errors */Plate$BwaxMobile.List.assoc_map((function (param) {
                  return partial_arg(Js_json.decodeString, param);
                }), /* [] */0),
          /* editing */actualInitialValues,
          /* validated */actualInitialValues,
          /* dirtyValues */Belt_List.concat(defaultValues, fixedValues),
          /* lastSaved */initialValues
        ];
}

function reducer(model, action) {
  switch (action.tag | 0) {
    case /* UpdateEditing */0 :
        var theKeys = action[0];
        var editing = takeInExcluding(model[/* editing */2], theKeys, action[1]);
        var errors = takeInExcluding(model[/* errors */1], theKeys, action[2]);
        var validated = takeInExcluding(model[/* validated */3], theKeys, action[3]);
        var dv = deriveDirtyValues(validated, model[/* lastSaved */5]);
        var dirtyValues = takeInExcluding(model[/* dirtyValues */4], theKeys, dv);
        return /* record */[
                /* actualInitialValues */model[/* actualInitialValues */0],
                /* errors */errors,
                /* editing */editing,
                /* validated */validated,
                /* dirtyValues */dirtyValues,
                /* lastSaved */model[/* lastSaved */5]
              ];
    case /* ClearEditing */1 :
        var cleared = action[1];
        var theKeys$1 = action[0];
        var editing$1 = takeInExcluding(model[/* editing */2], theKeys$1, cleared);
        var validated$1 = takeInExcluding(model[/* validated */3], theKeys$1, cleared);
        var errors$1 = takeInExcluding(model[/* errors */1], theKeys$1, /* [] */0);
        var dv$1 = deriveDirtyValues(cleared, model[/* lastSaved */5]);
        var dirtyValues$1 = takeInExcluding(model[/* dirtyValues */4], theKeys$1, dv$1);
        return /* record */[
                /* actualInitialValues */model[/* actualInitialValues */0],
                /* errors */errors$1,
                /* editing */editing$1,
                /* validated */validated$1,
                /* dirtyValues */dirtyValues$1,
                /* lastSaved */model[/* lastSaved */5]
              ];
    case /* Rollback */2 :
        var theKeys$2 = action[0];
        var toRollback = Belt_List.reduce(theKeys$2, /* [] */0, (function (acc, key) {
                var v = get(key, model[/* lastSaved */5]);
                return set(key, v, acc);
              }));
        var editing$2 = takeInExcluding(model[/* editing */2], theKeys$2, toRollback);
        var validated$2 = takeInExcluding(model[/* validated */3], theKeys$2, toRollback);
        var errors$2 = takeInExcluding(model[/* errors */1], theKeys$2, /* [] */0);
        var dirtyValues$2 = takeInExcluding(model[/* dirtyValues */4], theKeys$2, /* [] */0);
        return /* record */[
                /* actualInitialValues */model[/* actualInitialValues */0],
                /* errors */errors$2,
                /* editing */editing$2,
                /* validated */validated$2,
                /* dirtyValues */dirtyValues$2,
                /* lastSaved */model[/* lastSaved */5]
              ];
    case /* MarkSaved */3 :
        var theKeys$3 = action[0];
        var toMark = Belt_List.reduce(theKeys$3, /* [] */0, (function (acc, key) {
                var v = get(key, model[/* validated */3]);
                return set(key, v, acc);
              }));
        var lastSaved = takeInExcluding(model[/* lastSaved */5], theKeys$3, toMark);
        var dirtyValues$3 = takeInExcluding(model[/* dirtyValues */4], theKeys$3, /* [] */0);
        return /* record */[
                /* actualInitialValues */model[/* actualInitialValues */0],
                /* errors */model[/* errors */1],
                /* editing */model[/* editing */2],
                /* validated */model[/* validated */3],
                /* dirtyValues */dirtyValues$3,
                /* lastSaved */lastSaved
              ];
    case /* Reset */4 :
        return buildInitialState(action[0], action[1], action[2]);
    case /* SetErrors */5 :
        return /* record */[
                /* actualInitialValues */model[/* actualInitialValues */0],
                /* errors */takeInExcluding(model[/* errors */1], action[0], action[1]),
                /* editing */model[/* editing */2],
                /* validated */model[/* validated */3],
                /* dirtyValues */model[/* dirtyValues */4],
                /* lastSaved */model[/* lastSaved */5]
              ];
    
  }
}

function useEditingState(allKeys, defaultValues, initialValues, validators, fixedValues, stateKey, cacheEnabled) {
  var match = React.useReducer(reducer, buildInitialState(defaultValues, initialValues, fixedValues));
  var dispatch = match[1];
  var state = match[0];
  var getValidator = function (key) {
    var alwaysValid = function (v) {
      return /* record */[
              /* error */undefined,
              /* goodValue */v
            ];
    };
    var match = get(key, validators);
    if (match !== undefined) {
      return match;
    } else {
      return alwaysValid;
    }
  };
  var limitKeys = function (keys) {
    if (keys !== undefined) {
      return Belt_List.keep(keys, (function (k) {
                    return Belt_List.some(allKeys, (function (v) {
                                  return v === k;
                                }));
                  }));
    } else {
      return allKeys;
    }
  };
  var updateEditing = function (values) {
    var theKeys = limitKeys(keys(values));
    var match = Belt_List.reduce(theKeys, /* tuple */[
          /* [] */0,
          /* [] */0
        ], (function (acc, key) {
            var validated = acc[1];
            var errors = acc[0];
            var value = get(key, values);
            var match = Curry._1(getValidator(key), value);
            var error = match[/* error */0];
            if (error !== undefined) {
              return /* tuple */[
                      set(key, error, errors),
                      validated
                    ];
            } else {
              return /* tuple */[
                      errors,
                      set(key, match[/* goodValue */1], validated)
                    ];
            }
          }));
    return Curry._1(dispatch, /* UpdateEditing */Block.__(0, [
                  theKeys,
                  values,
                  match[0],
                  match[1]
                ]));
  };
  var setErrors = function (errors) {
    var theKeys = limitKeys(keys(errors));
    var errorsInScope = Belt_List.reduce(theKeys, /* [] */0, (function (acc, key) {
            var error = get(key, errors);
            return set(key, error, acc);
          }));
    return Curry._1(dispatch, /* SetErrors */Block.__(5, [
                  theKeys,
                  errorsInScope
                ]));
  };
  var clearEditing = function (keys) {
    var theKeys = limitKeys(Plate$BwaxMobile.$$Option.map(Plate$BwaxMobile.List.from_array, keys));
    var cleared = Belt_List.reduce(theKeys, /* [] */0, (function (acc, key) {
            var ivo = get(key, state[/* actualInitialValues */0]);
            return set(key, ivo, acc);
          }));
    return Curry._1(dispatch, /* ClearEditing */Block.__(1, [
                  theKeys,
                  cleared
                ]));
  };
  var rollback = function (keys) {
    var theKeys = limitKeys(Plate$BwaxMobile.$$Option.map(Plate$BwaxMobile.List.from_array, keys));
    return Curry._1(dispatch, /* Rollback */Block.__(2, [theKeys]));
  };
  var markSaved = function (keys) {
    var theKeys = limitKeys(Plate$BwaxMobile.$$Option.map(Plate$BwaxMobile.List.from_array, keys));
    return Curry._1(dispatch, /* MarkSaved */Block.__(3, [theKeys]));
  };
  var reset = function (defaultValues, initialValues, fixedValues) {
    return Curry._1(dispatch, /* Reset */Block.__(4, [
                  defaultValues,
                  initialValues,
                  fixedValues
                ]));
  };
  return /* record */[
          /* errors */state[/* errors */1],
          /* editing */state[/* editing */2],
          /* validated */state[/* validated */3],
          /* dirtyValues */state[/* dirtyValues */4],
          /* lastSaved */state[/* lastSaved */5],
          /* updateEditing */updateEditing,
          /* setErrors */setErrors,
          /* markSaved */markSaved,
          /* rollback */rollback,
          /* clearEditing */clearEditing,
          /* reset */reset
        ];
}

function useEditingStateAsJs(allKeys, initialValues, fixedValues, defaultValues, validators, stateKey, cacheEnabled) {
  var match = useEditingState(Belt_List.fromArray(allKeys), dictToOptionAssoc(defaultValues), dictToOptionAssoc(initialValues), Curry._1(Plate$BwaxMobile.List.from_array, validators), dictToOptionAssoc(fixedValues), stateKey, cacheEnabled);
  var reset = match[/* reset */10];
  var setErrors = match[/* setErrors */6];
  var updateEditing = match[/* updateEditing */5];
  return {
          errors: optionAssocToDict(match[/* errors */0]),
          validated: optionAssocToDict(match[/* validated */2]),
          editing: optionAssocToDict(match[/* editing */1]),
          lastSaved: optionAssocToDict(match[/* lastSaved */4]),
          dirtyValues: optionAssocToDict(match[/* dirtyValues */3]),
          updateEditing: (function (v) {
              return Curry._1(updateEditing, dictToOptionAssoc(v));
            }),
          setErrors: (function (es) {
              return Curry._1(setErrors, dictToOptionAssoc(es));
            }),
          markSaved: match[/* markSaved */7],
          rollback: match[/* rollback */8],
          clearEditing: match[/* clearEditing */9],
          reset: (function (defaultValues, initialValues, fixedValues) {
              return Curry._3(reset, dictToOptionAssoc(defaultValues), dictToOptionAssoc(initialValues), dictToOptionAssoc(fixedValues));
            })
        };
}

exports.get = get;
exports.set = set;
exports.keys = keys;
exports.dictToOptionAssoc = dictToOptionAssoc;
exports.optionAssocToDict = optionAssocToDict;
exports.mergeWith = mergeWith;
exports.takeInExcluding = takeInExcluding;
exports.toDict = toDict;
exports.deriveDirtyValues = deriveDirtyValues;
exports.buildInitialState = buildInitialState;
exports.reducer = reducer;
exports.useEditingState = useEditingState;
exports.useEditingStateAsJs = useEditingStateAsJs;
/* react Not a pure module */
